module.exports = __webpack_public_path__ + "static/media/PattiesTriangle.ec560535.jpg";